<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
					<b-nav-item class="filter" role="presentation" 
						@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>
		</div>
		<div class="row">
			<div class="col-md-12 search form minimize"> 
				<form class="search bright" :class="'formsearch' + idx" v-on:change="resumePilihan">
				
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Locations" name="detail1" v-model="detail1" :options="options.detail1" />
						</div>
						<div class="col-md-8 form-group">
							<ReportParamSearch title="Store" v-model="branch" :options="store.list" fldid="BranchId" fldinfo="BranchName" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Type" name="nfrtype" v-model="nfrtype" :options="options.nfrtype" />
						</div>
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 form-group" v-show="tabIndex != 1">
							<ReportParamSelect title="Items" name="detail2" v-model="detail2" :options="options.detail2" />
						</div>
					</div>

				</form>
			</div> 

		</div> 

		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="BrightReport" :reportdata="reportdata" :reporturl="urlRequestParams"/>
					<Loader :loading="this.loading.table" :customclass="''" class="child"/>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import {Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'


export default
{
	extends:Bright,
	components: {
		ReportParamSelect,
		ReportResultTable,
		ReportParamSearch,
		Loader,
	},
	computed:
	{
	},
	data() {
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			urlRequestParams: '',
			options: {
				periode:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'weekly', name: 'WEEKLY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "store", name: "BY STORE" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "div", name: "BY DIVISI" }, 
					{ value: "dep", name: "BY DEPARTMENT" },
					{ value: "item", name: "BY ITEM" }
				],
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				nfrtype:[
					{ value: "", name: "ALL" }, 
					{ value: "nfrtype", name: "BY TYPE", field: "BranchType1" }, 
					{ value: "BRIGHT", name: "STORE" }, 
					{ value: "CAFE", name: "CAFE" }, 
				],
			},
			tabList:[
				{name:'Performance'},
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			reportdata: [],
			branch: this.$route.query.branch ? this.$route.query.branch : '',
            periode: this.$route.query.period ? this.$route.query.period : 'monthly',
            detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
            detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
            area: this.$route.query.area ? this.$route.query.area : 'area',
			nfrtype: this.$route.query.nfrtype ? this.$route.query.nfrtype : '',
		}
	},
	watch:
	{
		tabIndex() { this.resumePilihan() },
		date(){ this.resumePilihan() },
		branch() { this.resumePilihan() },
	},      
	mounted(){
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
		document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		this.$emit('childrenRoute')		

		this.loadStoreList()
		this.resumePilihan()
	},
	methods:{
	
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		
		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/bright/performance?'
			this.urlRequestParams+='&period='+this.periode
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&nfrtype='+this.nfrtype
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2
			this.urlRequestParams+='&branch='+this.branch

			this.loading.table = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(/*error => {
					//console.log(error)
				}*/)
				.finally(() => {
					this.loading.table = false;
				})
		},

        searchFilterButtonClick(){
            document.querySelector('li.filter').classList.toggle('down')
            var select=document.querySelectorAll('.search.form')
            Array.from(select).map((e)=>{e.classList.toggle('minimize')})            
        }
    }
}
</script>
<style>
    .tabs .card-header{ padding-bottom:0px ;}
    .nav.nav-pills { background: rgba(20,109,182,.75) !important; border-radius: 10px 10px 0px 0px !important; padding: 0px !important; margin-top: 10px; }
    .nav.nav-pills .nav-link { color: #f8f9fa !important; border-radius: 5px 0px 0px 0px !important; background-color: none !important; margin-right: 10px !important; font-weight: 500; padding: 15px 20px; font-size: 0.875rem; }
    .nav.nav-pills .nav-link.active{ font-weight: bold; color: #f8f9fa  !important; background-color: transparent  !important;}
    .tab-pane.active { transition: all 0.5s ease-in-out; }
    .tab-pane.card-body { flex: 1 1 auto; padding: 0px 8px;  transition: all 0.5s ease-in-out;}
.search.form { background:#f8f9fa; border-radius:0px 0px 5px 5px; color:#666; padding:20px;   transition: all 0.5s ease-in-out;}
.search.form.minimize{ padding:0px; height:2px; overflow:hidden; }
    .nav.nav-pills li.filter .nav-link{ position: absolute; right:0px; bottom: 0px; top: 0px; display: flex;
    align-items: center; }
    

.search.form.floating {
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 750px;
    height: 300px;
    z-index: 9;
    background: rgba(172,196,55,.75);
    padding: 20px;
    border-radius: 15px 15px 0px 15px;
    overflow-Y: scroll;
    }
    .table .card .card-header{ display:none;}
    .table .card .card-body{ padding: 0px;}
    .table.pdf{ border:0px; }
    .table.pdf tr,.table.pdf td,.table.pdf th{ border:0px; }
    .table.pdf tbody tr:nth-child(2n+2){ background:#f1f1f1; }
    
    .table.pdf thead tr{ background: #ccc; color:#333;}
 

    .filter .icon-up { display: flex; }
    .filter.down .icon-up { display: none; }
    .filter .icon-down { display: none; }
    .filter.down .icon-down { display: flex; }


 

</style>